
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Gingivitis(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Gingivitis"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Gingivitis is a <b> common and mild form of gum disease
                                        (periodontal disease)</b> that causes irritation, redness and
                                    swelling (inflammation) of your gingiva, the part of your gum
                                    around the base of your teeth. It's important to take gingivitis
                                    seriously and treat it promptly.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Gingivitis/1.png")} alt="Gingivitis" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
<p><b>Healthy gums are firm and pale pink and fitted tightly around the teeth.
Signs and symptoms of gingivitis include:</b></p>
                                <p>  Swollen or puffy gums</p>
                                <p>Dusky red or dark red gums</p>
                                <p> Gums that bleed easily when you brush or floss</p>
                                <p> Bad breath</p>
                                <p> Receding gums, Tender gums</p>


                                <a className="links" href="https://en.wikipedia.org/wiki/Gingivitis">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Gingivitis;